module.exports = __webpack_public_path__ + "img/IMG_5002_L_BlackMatted_MockedUp.7f8cb05a.jpg";